import { FC } from 'react';
import { Product } from '@/models/product';
import Link from 'next/link';
import { MENU_LINKS } from '@/constants';
import { getArticlePath, getKeyValue } from '@/utils/helper';

type ErrorPageLinksProps = {
  shopCategories: Product[];
  mostLovedRecipes: Product[];
  mostViewedStories: Product[];
  upcomingWorkshops: Product[];
};

const ErrorPageLinks: FC<ErrorPageLinksProps> = ({
  shopCategories,
  mostLovedRecipes,
  mostViewedStories,
  upcomingWorkshops,
}) => {
  return (
    <div className='m-8 flex flex-col flex-wrap justify-evenly gap-4 md:m-0 md:my-16 md:flex-row'>
      <div className='mb-8 flex w-full flex-col items-start justify-start gap-4 md:w-1/5'>
        <div className='text-lg font-semibold'>Shop by Category</div>
        <div className='w-full border border-pink-800'></div>
        {shopCategories.map(({ name, id, custom_attributes }) => {
          const customAttributes =
            custom_attributes &&
            getKeyValue(custom_attributes, 'attribute_code');
          return (
            <Link
              href={`/shop/${customAttributes?.url_key}`}
              key={id}
              className='text-base font-medium'>
              {name}
            </Link>
          );
        })}
      </div>
      <div className='mb-8 flex w-full flex-col items-start justify-start gap-4 md:w-1/5'>
        <div className='text-lg font-semibold'>Most Loved Recipes</div>
        <div className='w-full border border-pink-800'></div>
        {mostLovedRecipes.map(({ name, id, sku }) => (
          <Link
            href={`${MENU_LINKS.RECIPES}/${sku}`}
            key={id}
            className='text-base font-medium'>
            {name}
          </Link>
        ))}
      </div>
      <div className='mb-8 flex w-full flex-col items-start justify-start gap-4 md:w-1/5'>
        <div className='text-lg font-semibold'>Most Viewed Stories</div>
        <div className='w-full border border-pink-800'></div>
        {mostViewedStories.map(({ name, id, sku, extension_attributes }) => (
          <Link
            key={id}
            href={`${getArticlePath(
              extension_attributes?.attribute_set_name
            )}/${sku}`}
            className='text-base font-medium'>
            {name}
          </Link>
        ))}
      </div>
      <div className='mb-8 flex w-full flex-col items-start justify-start gap-4 md:w-1/5'>
        <div className='text-lg font-semibold'>Upcoming Workshops</div>
        <div className='w-full border border-pink-800'></div>
        {upcomingWorkshops.map(({ name, id }) => (
          <Link
            key={id}
            href='/kitchen-studio/?tag=events-list'
            className='text-base font-medium'>
            {name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ErrorPageLinks;
